// extracted by mini-css-extract-plugin
module.exports = {"loaderwrapper":"UzraQ","loading_spinner":"aQKeu","spin":"_dBwl"};